import { Component, OnInit, Input, QueryList, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { RouteInfoService } from 'src/app/services/route-info.service';
import { AuthenticationService } from 'src/app/security/services/authentication.service';
import { UserCache } from 'src/app/services/user-cache';
import { LoginMenu } from 'src/app/permission/models/login-menu';
import { BaseConfig } from 'src/app/services/base-config.service';
import { MatMenuTrigger } from '@angular/material/menu';
import { OverlayContainer } from '@angular/cdk/overlay';
import { IBaseConfig } from 'src/app/shared/models/base-config';
import { LocalStoragesService } from 'src/app/services/local-storages.service';
import { MenuItem } from 'src/app/models/MenuItem';
import { AppComponent } from 'src/app/app.component';
import { ClinicDataService } from 'src/app/services/data-service/clinic-data-service';
import { EasyNotificationService } from 'src/app/services/easy-notification.service';
import { PATIENT_CARE_FUNCTION_CODE, PolarisHostService } from 'src/app/services/polaris-host.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css'],

})
export class MenuComponent implements OnInit {
  public static Instance: MenuComponent;
  @Input() isVertical: boolean;
  @Input() menuItems: LoginMenu[];

  isDental: boolean = UserCache.IsDentistMode();
  polarisChecking = false;
  polarisReachable = false;
  config: IBaseConfig;
  constructor(private router: Router, private overlayContainer: OverlayContainer,
    private routeInfo: RouteInfoService,
    private auth: AuthenticationService,
    private localStorage: LocalStoragesService,
    private clinicDataService: ClinicDataService,
    private polarisHostService: PolarisHostService,
    private notification: EasyNotificationService) {
    this.config = BaseConfig.getConfig();
    MenuComponent.Instance = this;
  }

  selectedIndex = -1;

  get isUseLeftMenu(): boolean {
    if (BaseConfig.getConfig().env.menuType === 'left') {
      return true;
    } else {
      return false;
    }
  }
  get menuCssClass(): string {
    if (this.isUseLeftMenu) {
      return 'left-menu';
    } else {
      return 'top-menu';
    }
  }
  allowCloseOnClickOut() {
    this.overlayContainer.getContainerElement().classList.remove('disable-backdrop-click');
  }
  closeMenu() {
    this.triggers.forEach(item => {

      item.closeMenu();
    });
  }

  // onMenuItemClick(item: LoginMenu, index) {
  //   this.selectedIndex = index;
  //   if (!item.path) { return; }
  //   if (!item.param) { item.param = {}; }
  //   const path = this.routeInfo.makeFullUrl(item.path);
  //   this.router.navigate([path, item.param]);
  // }

  private createMenuData() {
    const menus = UserCache.getLoginUser().Menus || [];
    const polarisHostUrl = this.clinicDataService.GetPolarisHostUrl();
    this.menuItems = menus.map(item => ({
      ...item,
      children: (item.children || []).filter(child =>
        !this.isPatientCareMenuItem(child) || !!polarisHostUrl)
    }));
    // console.log('menuItems:', this.menuItems);
    // 不取Menu之首頁
    this.menuItems = this.menuItems.filter(x => x.text != '首頁');

  }

  resetMenu(){
    this.createMenuData();
    this.beginPolarisProbe();
  }

  @ViewChildren(MatMenuTrigger)
  triggers: QueryList<MatMenuTrigger>;
  menu: MenuItem[] = [];
  ngOnInit(): void {
    this.createMenuData();
    this.beginPolarisProbe();
    setTimeout(() => {
      const m = new MenuItem();
      m.children = this.menu;
      //this.eventService.fire(EventKey.MenuChanged,this.findCurrentItem(m)?.text);
    }, 100);

  }
  private findCurrentItem(menuItem: MenuItem) {
    if (menuItem.path == this.router.url) {
      return menuItem;
    } else {
      if (menuItem.children.length > 0) {
        for (let i = 0; i < menuItem.children.length; i++) {
          const childItem = this.findCurrentItem(menuItem.children[i]);
          if (childItem) {
            return childItem;
          }
        }
      }
      return null
    }
  }
  onMenuOpen(e: string, open: boolean) {
    this.triggers.forEach(item => {
      if (item.menuData != e) {
        item.closeMenu();
        if (open) {
          item.openMenu();
        }
      }
    })

  }
  onMenuHover(trigger: MatMenuTrigger, event?: MouseEvent) {
    this.triggers.forEach(item => {
      if (item !== trigger) {
        item.closeMenu();
      }
    });
    trigger.openMenu();
  }

  get menuPanelClass(): string {
    return this.isDental ? 'dental-app-menu-panel' : '';
  }

  isMenuItemSelected(menuItem: MenuItem): boolean {
    if (!this.isDental || !menuItem) {
      return false;
    }

    if (menuItem.path) {
      const loginUser = UserCache.getLoginUser();
      const menuUrl = MenuItem.getUrl(menuItem, loginUser?.CompanyCode);
      if (this.normalizeUrl(this.router.url) === this.normalizeUrl(menuUrl)) {
        return true;
      }
    }

    return (menuItem.children || []).some(child => this.isMenuItemSelected(child));
  }

  private normalizeUrl(url: string): string {
    const cleanUrl = (url || '').split('?')[0].split('#')[0];
    return cleanUrl.length > 1 ? cleanUrl.replace(/\/+$/, '') : cleanUrl;
  }

  async redirectTo(menuItem: MenuItem) {
    if (this.isPatientCareMenuItem(menuItem)) {
      const reachable = await this.ensurePolarisReachable();
      if (!reachable) {
        this.notification.showWarning('找不到北極星主機');
        return;
      }
    }

    //this.clearKeepWaitListData(); 先關起來看起來都沒用到
    var loginUser = UserCache.getLoginUser();
    var url = MenuItem.getUrl(menuItem, loginUser?.CompanyCode);
    if (this.router.url == url) {
      return
    }
    var canRedirect = await this.routeInfo.onMenuClick();
    if (canRedirect == false) {
      return;
    }
    if (menuItem.funcSystemId == 2) {
      var hcUrl = this.config.homeCare.hcUrl;
      var ssotoken = loginUser?.SSOToken;
      var parm = "?s=" + ssotoken;
      var tempUrl = url.startsWith("/") ? url.substring(1) : url;
      var go = (window as Window).location.assign(hcUrl + tempUrl + parm);
    } else {
      // this.eventService.fire(EventKey.ShowLoading,true);
      setTimeout(() => {
        //this.eventService.fire(EventKey.MenuChanged,menuItem.text);
        this.router.navigateByUrl(url);

        // 把目前掛的comp清掉
        this.routeInfo.comp = null;
      }, 0);
    }
  }

  isPatientCareMenuItem(menuItem: any): boolean {
    return menuItem?.functionCode === PATIENT_CARE_FUNCTION_CODE
      || menuItem?.path === 'registers/patient-care';
  }

  isPatientCareUnavailable(menuItem: any): boolean {
    return this.isPatientCareMenuItem(menuItem)
      && (this.polarisChecking || !this.polarisReachable);
  }

  private beginPolarisProbe(): void {
    if (!this.menuItems.some(item => this.containsPatientCareMenuItem(item))) {
      this.polarisChecking = false;
      this.polarisReachable = false;
      return;
    }

    this.polarisChecking = true;
    this.polarisHostService.probeOnce().then(result => {
      this.polarisReachable = result;
      this.polarisChecking = false;
    }).catch(() => {
      this.polarisReachable = false;
      this.polarisChecking = false;
    });
  }

  private async ensurePolarisReachable(): Promise<boolean> {
    if (this.polarisReachable) {
      return true;
    }

    this.polarisChecking = true;
    try {
      const result = await this.polarisHostService.probeOnce();
      this.polarisReachable = result;
      return result;
    } catch {
      this.polarisReachable = false;
      return false;
    } finally {
      this.polarisChecking = false;
    }
  }

  private containsPatientCareMenuItem(menuItem: any): boolean {
    return this.isPatientCareMenuItem(menuItem)
      || (menuItem?.children || []).some(child => this.containsPatientCareMenuItem(child));
  }

  clearKeepWaitListData() {
    var loginUserCid = UserCache.getLoginUser().CId;
    this.localStorage.setItem("WaitingList_ToRegister_" + loginUserCid, false);
    this.localStorage.setItem("WaitingList_NeedKeep_" + loginUserCid, false);
    this.localStorage.setItem("WaitingList_PageSkipNo_" + loginUserCid, 0);
    this.localStorage.setItem("WaitingList_PatientRegId_" + loginUserCid, 0);
  }
}
